export default __webpack_public_path__ + "static/media/iam_s3.18d23ed5.png";